/** AMS-ready filament slot model (UI is single-filament for v1). */
export interface FilamentSlot {
  id: string;
  type: string;
  colour: string;
  name: string;
  temperature: number;
  bedTemperature: number;
  flowRatio: number;
  density: number;
}

export function defaultSlots(): FilamentSlot[] {
  return [
    {
      id: 'slot-1',
      type: 'PLA',
      colour: '#00AE42',
      name: 'Bambu PLA Basic',
      temperature: 220,
      bedTemperature: 55,
      flowRatio: 0.98,
      density: 1.26,
    },
  ];
}
